export const getPatients = (state) => {
    return state.patient.patient
};
